module.exports = __webpack_public_path__ + "static/img/saftybelt.2a01530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saftybelt.png
// module id = 3xuw
// module chunks = 21